module.exports = __webpack_public_path__ + "media/images/menu/lacerta-0b9002d02288071c26b572e2e973953f.jpg";